import { GetOdataAdsAPIParams, getFullUrlOfAdsOdata, WithEntityPath } from './adsOdata';
import { DateRange } from './listingGroupGridData';
import { Model$ProductOffer, Header } from '../ApiType';

interface ProductOfferEntityPath {
  productListingGroupId: number;
}

interface ProductOfferPayload {
  gridDataParameters: {
    DateRange: DateRange;
  },
}

export type ProductOfferParams = GetOdataAdsAPIParams<ProductOfferPayload> & WithEntityPath<ProductOfferEntityPath>;

export interface ProductOfferResponse {
  value: Model$ProductOffer[];
  headers: Header;
}

// when editing tree view, the opened panel is also a grid, use this API to get data.
export function productOfferRequest(baseUrl: string, params: ProductOfferParams) {
  const path = `ProductListingGroups(${params.entityPath.productListingGroupId})/ProductOffers/Default.GetProductOffersForListingGroup`;
  const finalUrl = getFullUrlOfAdsOdata(baseUrl, path, params);
  return [finalUrl, {
    method: 'GET',
  }];
}

export async function productOfferResponseHandler(responsePromise: Promise<Response>) {
  const p$response = await responsePromise;
  const response: ProductOfferResponse = await p$response.json();
  response.headers = p$response.headers;

  return response;
}
